import { defineStore, acceptHMRUpdate } from 'pinia'

export interface EditServiceCategoryData {
  // Pre-filled values when opening the service category form for editing.

  name: string
  // Category display name.

  description: string | null
  // Optional category description; null when absent.
}

export const useAddServiceCategoryFormStore = defineStore('addServiceCategoryForm', {
  state: () => ({
    isOpen: false,
    editId: null as string | null,
    editData: null as EditServiceCategoryData | null,
  }),
  actions: {
    open(): void {
      this.isOpen = true
      this.editId = null
      this.editData = null
    },
    openForEdit(id: string, data: EditServiceCategoryData): void {
      this.isOpen = true
      this.editId = id
      this.editData = data
    },
    close(): void {
      this.isOpen = false
      this.editId = null
      this.editData = null
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAddServiceCategoryFormStore, import.meta.hot))
}
